import type ContentManager from '@tribal-worldwide-london/fa-content';
import { ERROR_STATUS_KEYS } from '@/constants/error';
import { throwErrorAction, throwJsonAction } from '../actions';

export const isJsonResponse = (e: any) =>
  e.status && typeof e.json === 'function';

let hasFoundAnySuccess = false;

export const handleAllErrors = (
  responses: any[],
  contentManager: Pick<ContentManager, 'get'>,
  isLastBatch: boolean
) => {

  if (responses.length === 0) {
    if (isLastBatch && !hasFoundAnySuccess) {
      const errorMessage = contentManager.get('error-general');
      throwErrorAction(errorMessage);
    }
    return;
  }
  
  // The rest of your code
  const hasSuccessfulResponseInThisBatch = responses.some(
    ({ code, errors, data }) => {
      return code === 200 || (errors && errors.length === 0 && data);
    }
  );

  if (hasSuccessfulResponseInThisBatch) {
    hasFoundAnySuccess = true;
  }
  
  if (isLastBatch && !hasFoundAnySuccess) {
      const errorMessage = contentManager.get('error-general');
      throwErrorAction(errorMessage);
  }
};

export const throwResponseError = (
  status: number,
  contentManager: Pick<ContentManager, 'get'>,
  messageKey?: string
) => {
  const errorMessage =
    contentManager.get(messageKey || `error-${status}`) ||
    contentManager.get('error-general');

  throwJsonAction(errorMessage, {
    status,
  });
};
